import { useSchoolVisual } from 'applications/GSP/shared/hooks/school';

export const useSetFavicon = () => {
  const favIconUrl = useSchoolVisual()?.favIconUrl;
  const link = document.querySelector('link[rel="icon"]');

  if (favIconUrl && link) {
    link.setAttribute('href', favIconUrl);
  }
};
